import React, { useState } from "react";

function DateRangeCost({ field, onChange, onComplete }) {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  function _onChange(startDate, endDate) {
    startDate.setHours(5, 0, 0, 0);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(4, 59, 59, 999);

    const where = {};
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString(),
    };
    onChange(where);
  }

  function _onChangeStart(date) {
    const iso = date.toISOString().slice(0, 10);
    setStart(iso);
    end && _onChange(date, new Date(end));
  }

  function _onChangeEnd(date) {
    const iso = date.toISOString().slice(0, 10);
    setEnd(iso);
    start && _onChange(new Date(start), date);

    // ✅ Auto-close after selecting end date if start is present
    if (start && typeof onComplete === "function") {
      onComplete();
    }
  }

  function handleClear() {
    setStart(undefined);
    setEnd(undefined);
    onChange({});
  }

  return (
    <div className="mt-5">
      <label>Start Date</label>
      <input
        className="form-control form-control-md shadow-none mb-2"
        value={start || ""}
        onInput={(e) => _onChangeStart(e.target.valueAsDate)}
        type="date"
        placeholder="Start Date"
      />
      <label>End Date</label>
      <input
        className="form-control form-control-md shadow-none mb-2"
        value={end || ""}
        onInput={(e) => _onChangeEnd(e.target.valueAsDate)}
        type="date"
        placeholder="End Date"
      />
      <button
        className="btn w-100 mt-3 fw-bold"
        onClick={handleClear}
        style={{ backgroundColor: "#82c14a", color: "white" }}
      >
        Clear
      </button>
    </div>
  );
}

export default DateRangeCost;
